import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * Bloqueio/liberação de lançamento — migração das telas legadas do Menu Gestão de Usuários.
 *
 * `BloqueioLancamentoEnsinoGeral.aspx` NÃO ganhou rota própria: ela fazia exatamente o que a
 * tela por escola faz, só que para todas as escolas, e virou um botão dentro de
 * `bloqueio_etapa_ensino`.
 *
 * Permissões: as duas telas usam permissão PRÓPRIA, criada para elas
 * (`...ENSINONOVO_MENU_2290000099` e `...PROFESSORNOVO_MENU_2290000098`). Não reusam as do
 * legado (2290000008 / 2290000009 / 2290000010): como a tela por ensino absorveu a Geral, uma
 * permissão só passa a valer pelas duas funções, e misturar isso com a permissão antiga daria
 * a função Geral a quem só tinha a tela por escola. Ver
 * `consultebase/scripts/2026-08-28-Permissoes-TelasNovas.sql`.
 */
export default [
  {
    description: 'Etapa Atual e Bloqueio por Ensino',
    path: '/administracao/bloqueiolancamento/ensino',
    name: 'bloqueio_etapa_ensino',
    component: () =>
      import('@/views/administracao/bloqueiolancamento/EtapaEnsino.vue'),
    meta: {
      permissions: [eTipoPermissao.BLOQUEIOLIBERACAODEETAPAPORENSINONOVO_MENU_2290000099],
    },
    goesToMenu: true,
  },
  {
    description: 'Liberação de Lançamento por Professor',
    path: '/administracao/bloqueiolancamento/professor',
    name: 'bloqueio_liberacao_professor',
    component: () =>
      import('@/views/administracao/bloqueiolancamento/LiberacaoProfessor.vue'),
    meta: {
      permissions: [eTipoPermissao.BLOQUEIOLIBERACAODEETAPAPORPROFESSORNOVO_MENU_2290000098],
    },
    goesToMenu: true,
  },
];
